import { createSelector } from '@reduxjs/toolkit';

import { getChildrenFinder, getComponentDesignDescendantGuids } from '@paragon/layout-models';

import { getProjectLayoutModels } from './getProjectLayoutModels';

export const getComponentDesignGuidsByProjectGuid = createSelector(
  getProjectLayoutModels,
  getChildrenFinder,

  (projectLayoutModels, childrenFinder) =>
    projectLayoutModels.reduce(
      (componentDesignGuidsByProjectGuid, projectLayoutModel) => {
        const componentDesignGuidsForProject = getComponentDesignDescendantGuids(
          projectLayoutModel.guid,
          childrenFinder,
        );
        componentDesignGuidsByProjectGuid[projectLayoutModel.guid] = componentDesignGuidsForProject;
        return componentDesignGuidsByProjectGuid;
      },
      {} as { [projectGuid: string]: readonly string[] },
    ),
);
